import { render, staticRenderFns } from "./UploadFulfillmentOrders.vue?vue&type=template&id=f5c7cd2c"
import script from "./UploadFulfillmentOrders.vue?vue&type=script&lang=js"
export * from "./UploadFulfillmentOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports